<ng-container *ngIf="googleAPISet | async" class="map-container">
	<google-map #googleMap [options]="mapConfiguration.options" [width]="width ? width : '100%'" [center]="
			mapConfiguration.centerLocation
				? mapConfiguration.centerLocation
				: mapConfiguration.mainLocation.location
		" [zoom]="zoom ? zoom : 15" [height]="height" (mapClick)="onClickMap($event)" (idle)="onIdle()"
		id="google-map-container">
		<map-marker [position]="mapConfiguration.mainLocation.location" [icon]="mapConfiguration.mainLocation.icon"
			[options]="{ draggable: false }">
		</map-marker>
		<map-marker *ngFor="let locationModel of mapConfiguration.locationModels" #marker="mapMarker"
			[position]="locationModel.position" [icon]="locationModel.iconUrl"
			[options]="{ draggable: false, optimized: false }"
			(mapClick)="mapConfiguration.markerClicked(marker, infoWindow, locationModel)">
		</map-marker>
		<map-marker *ngIf="newMarker !== null" [position]="newMarker" [options]="{ draggable: true, optimized: false }"
			[icon]="defaultIcon" (mapMouseout)="onMarkerDragend($event)">
		</map-marker>
		<map-info-window>
			<div class="info-window" *ngIf="mapConfiguration.selectedLocationModel !== null">
				<div>
					<img height="120" [src]="
							mapConfiguration.selectedLocationModel.thumbnailPath !== ''
								? mapConfiguration.selectedLocationModel.thumbnailPath
								: mapConfiguration.selectedLocationModel.imagePath
						" />
				</div>
				<div class="info-data">
					<span>{{ mapConfiguration.selectedLocationModel.property.enumType.Type }}</span>
					<p>
						{{ mapConfiguration.selectedLocationModel.description }}
						<label *ngIf="mapConfiguration.selectedLocationModel.subCategory">
							Type: {{ mapConfiguration.selectedLocationModel.subCategory }}
						</label>
					</p>
				</div>
			</div>
		</map-info-window>
	</google-map>
</ng-container>

<!-- <ng-template #googleMapLoader>
        <div class="map-location-loader">
            <div class="card skeleton">
                <div class="card-body">
                    <div class="card-img card-img-bottom loading">
                        <div class="loader-icon">
                            <i class="fas fa-map-marked-alt"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template> -->

<!-- <div (click)="showLabelsToggle()"
     [id]="randomIdMap"
     class="map-control">
    <input type="checkbox"
           [(ngModel)]="showLabelsFlag"
           name="show-hide"
           id="show-labels"
           class="selector-control" />
    <label for="hide-poi">Show labels</label>
</div> -->
<div class="convert-unit-container" id="convertUnit{{randomIdMap}}">
	<div *ngIf="isPolylineEnabled" class="convert-unit-btn-container">
		<button type="button" class="convert-unit" [ngClass]="{'is-active': currentUnit === 'miles'}"
			(click)="convertUnit('miles')">Miles</button>
		<button type="button" class="convert-unit" [ngClass]="{'is-active': currentUnit === 'ft'}"
			(click)="convertUnit('ft')">Ft</button>
	</div>
</div>

<div title="" id="contextMenu{{randomIdMap}}" class="contextMenu">
	<ul>
		<li [ngClass]="{'disabled-list': isPinSelectorMode}">
			<span [ngClass]="{ 'cursor-not-allowed': isPinSelectorMode }" (click)="togglePoly()">
				{{measureDistanceLabel}} </span>
		</li>
	</ul>
</div>